<div class="row space-between align-center gap-8 header">
    <img
        src="images/logo_name.svg"
        alt="ideastream.io Logo mit Text"
        class="logo"
    />
    <rr-btn
        type="Primary"
        size="small"
        iconStart="close"
        (btnclick)="close()"
        i18n
        >Close</rr-btn
    >
</div>
<div class="wrapper w100 grow-1">
    <h1 i18n>Profile Settings</h1>
    <rr-tab-control [activeStep]="activeStep">
        <rr-tab step="1" label="Basic Settings">
            <app-basic-settings></app-basic-settings>
        </rr-tab>
        <rr-tab step="2" label="License & Seats">
            <app-license-settings></app-license-settings>
        </rr-tab>
    </rr-tab-control>
    <rr-disclaimer [type]="disclaimerTypes" [showIcon]="false"></rr-disclaimer>
</div>
